var GPLUS = {
	name: "GPLUS",
	defaultCommandIndex: 1,
	commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [227,0,5,113,2,238,0,106,14,217,5,101,2,117,4,159,2,58,1,166,2,0,0,73,231,38,114,100,231,63,255,254,114,127,38,127,255,255,255,252,127,147,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,128,2,236,0,125,14,191,5,114,2,84,4,156,2,59,1,177,2,0,0,73,231,38,114,100,231,63,199,248,206,114,127,36,159,255,255,255,255,255,38,115,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,105,2,236,0,100,2,102,4,84,14,218,5,143,2,44,1,183,2,0,0,43,221,110,181,221,255,255,187,175,245,127,255,255,255,255,252,91,176,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,111,2,238,0,103,14,203,5,100,2,97,4,164,2,55,1,120,2,0,0,73,231,38,114,100,231,63,255,243,156,159,204,159,255,31,255,255,255,231,57,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,113,2,243,0,78,14,210,5,102,2,118,4,108,2,62,1,94,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,249,63,255,255,254,63,199,255,57,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,113,2,240,0,88,14,210,5,109,2,101,4,161,2,45,1,98,2,0,0,73,231,38,114,100,231,63,199,254,115,147,249,51,255,255,255,255,255,228,158,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,88,2,251,0,76,14,208,5,103,2,118,4,125,2,67,1,87,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,243,63,254,63,199,255,255,252,158,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,101,2,242,0,77,14,208,5,110,2,98,4,135,2,52,1,110,2,0,0,73,231,38,114,68,156,231,248,255,206,114,127,57,241,255,255,255,255,254,103,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,102,2,242,0,86,14,210,5,109,2,96,4,106,2,60,1,144,2,0,0,73,231,38,114,68,156,231,255,248,206,114,127,231,255,255,255,255,199,248,207,48,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,115,2,242,0,73,14,189,5,119,2,110,4,105,2,84,1,145,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,39,255,255,255,255,255,228,249,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,119,2,239,0,122,14,169,5,135,2,78,4,144,2,65,1,144,2,0,0,73,231,38,114,100,231,63,199,254,115,147,252,159,255,255,255,143,255,249,243,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,103,2,242,0,69,14,222,5,90,2,120,4,115,2,57,1,111,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,230,126,63,199,255,255,255,249,249,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,112,2,241,0,82,14,192,5,101,2,109,4,101,2,51,1,90,2,0,0,73,231,38,114,68,156,231,248,255,17,57,201,252,103,227,252,127,143,255,255,255,204,32],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,112,2,243,0,73,14,204,5,111,2,98,4,121,2,71,1,135,2,0,0,73,231,38,114,100,231,63,255,243,156,159,201,255,255,252,127,255,255,146,73,56,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,116,2,241,0,82,14,190,5,118,2,94,4,110,2,55,1,148,2,0,0,73,231,38,114,100,231,63,255,30,115,147,252,255,255,255,255,255,255,36,147,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,105,2,253,0,111,2,92,4,70,14,204,5,140,2,68,1,114,2,0,0,43,221,110,162,187,191,199,254,238,191,191,255,199,255,255,255,251,85,194],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,117,2,240,0,81,14,191,5,125,2,88,4,142,2,70,1,119,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,255,255,255,255,255,255,249,36,225],
		},
		//////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [227,0,5,117,2,245,0,75,14,193,5,120,2,95,4,111,2,79,1,153,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,36,252,254,63,255,255,255,204,156,194],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [227,0,5,128,2,236,0,76,14,186,5,119,2,93,4,131,2,60,1,183,2,0,0,73,231,38,114,100,231,63,199,254,115,147,248,146,126,127,255,31,255,255,249,57,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [227,0,5,107,2,242,0,118,14,215,5,86,2,107,4,115,2,75,1,105,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,147,243,248,255,31,255,255,228,206,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [227,0,5,100,2,240,0,60,14,211,5,107,2,100,4,117,2,52,1,141,2,0,0,73,231,38,114,68,156,231,248,255,206,114,127,25,63,63,255,255,255,255,204,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [227,0,5,116,2,249,0,88,14,182,5,128,2,77,4,128,2,71,1,159,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,51,226,127,255,31,255,255,231,57,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [227,0,5,105,2,238,0,54,14,217,5,104,2,103,4,115,2,55,1,112,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,226,103,231,255,255,255,255,254,115,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [227,0,5,108,2,244,0,72,14,191,5,118,2,90,4,117,2,79,1,105,2,0,0,73,231,38,114,100,231,63,255,243,156,159,206,124,79,227,252,127,255,255,146,121,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [227,0,5,110,2,252,0,106,14,188,5,118,2,87,4,120,2,81,1,102,2,0,0,73,231,38,114,100,231,63,255,198,115,147,255,63,63,255,255,255,255,201,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [227,0,5,98,2,240,0,51,14,210,5,110,2,106,4,120,2,53,1,154,2,0,0,73,231,38,114,68,156,231,248,255,206,114,127,36,252,79,255,255,255,255,230,121,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [227,0,5,103,2,235,0,73,14,194,5,117,2,115,4,102,2,61,1,93,2,0,0,73,231,38,114,68,156,230,63,248,196,103,57,63,201,252,143,199,255,255,248,255,207,48,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [227,0,5,108,2,239,0,96,14,200,5,108,2,101,4,142,2,47,1,106,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,159,137,255,255,255,252,127,147,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [227,0,5,97,2,246,0,61,14,235,5,82,2,122,4,104,2,63,1,154,2,0,0,73,231,38,114,68,156,231,255,248,206,114,127,207,231,255,255,255,255,249,243,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [227,0,5,131,2,237,0,93,14,177,5,132,2,76,4,137,2,70,1,142,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,63,207,255,255,255,255,231,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [227,0,5,117,2,240,0,85,14,175,5,132,2,88,4,118,2,69,1,131,2,0,0,73,231,38,114,100,231,63,255,243,156,159,231,249,255,252,127,255,255,254,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [227,0,5,114,2,241,0,74,14,197,5,116,2,69,4,121,2,54,1,150,2,0,0,73,231,38,114,68,156,231,255,143,206,114,127,63,196,255,255,255,255,254,73,36,225],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [227,0,5,122,2,239,0,96,14,169,5,129,2,84,4,141,2,64,1,160,2,0,0,73,231,38,114,100,231,63,255,243,156,159,255,231,255,241,255,255,255,36,147,132],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [227,0,5,104,2,244,0,110,14,183,5,103,2,108,4,141,2,58,1,137,2,0,0,73,231,38,114,68,156,231,248,255,137,206,79,228,147,228,254,63,255,255,255,228,156,194],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [227,0,5,110,2,247,0,114,2,104,4,111,14,187,5,64,2,70,1,145,2,0,0,43,221,110,162,187,191,199,248,221,215,250,190,191,255,255,255,255,181,216,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [227,0,5,112,2,247,0,90,14,193,5,119,2,94,4,131,2,68,1,121,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,230,79,147,255,255,255,255,254,78,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [227,0,5,102,2,241,0,95,2,112,4,69,14,215,5,109,2,59,1,148,2,0,0,43,221,110,181,221,255,254,55,117,252,107,235,255,255,255,255,250,221,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [227,0,5,101,2,239,0,112,2,106,4,69,14,195,5,98,2,64,1,145,2,0,0,43,221,110,181,221,254,63,24,221,215,245,190,163,248,255,199,255,199,248,183,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [227,0,5,118,2,246,0,79,14,186,5,122,2,91,4,105,2,79,1,118,2,0,0,73,231,38,114,100,231,63,255,243,156,159,196,207,147,255,255,248,255,31,231,57,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [227,0,5,93,2,249,0,85,14,221,5,83,2,132,4,89,2,75,1,114,2,0,0,73,140,228,206,72,147,156,199,227,252,103,57,63,156,249,63,255,255,255,255,243,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [227,0,5,104,2,243,0,91,14,203,5,100,2,116,4,136,2,54,1,115,2,0,0,73,231,38,114,100,231,63,199,248,206,114,127,28,249,63,255,143,241,255,254,73,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [227,0,5,113,2,242,0,72,14,217,5,96,2,102,4,122,2,55,1,128,2,0,0,73,231,38,114,68,156,231,248,255,206,114,127,36,252,159,255,255,199,255,252,158,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [227,0,5,103,2,247,0,101,14,214,5,97,2,113,4,118,2,78,1,133,2,0,0,73,231,38,114,100,231,63,199,248,206,114,127,18,126,79,227,255,255,255,252,207,48,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [227,0,5,97,2,245,0,101,2,112,4,73,14,217,5,141,2,66,1,106,2,0,0,43,221,110,181,221,254,63,198,238,191,183,235,248,255,255,255,255,27,216,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [227,0,5,92,2,249,0,97,2,117,4,84,14,212,5,137,2,64,1,111,2,0,0,43,27,173,212,87,119,248,255,27,186,255,191,95,255,255,199,255,250,251,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [227,0,5,109,2,239,0,93,14,224,5,94,2,113,4,121,2,47,1,133,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,228,254,79,227,255,255,255,252,79,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [227,0,5,109,2,244,0,73,14,219,5,104,2,104,4,109,2,60,1,123,2,0,0,73,231,38,114,100,231,63,199,248,206,114,127,159,201,252,127,255,255,255,159,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [227,0,5,127,2,238,0,85,14,184,5,120,2,99,4,142,2,69,1,144,2,0,0,73,231,38,114,100,231,63,255,243,156,159,207,242,127,31,255,255,255,255,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [227,0,5,132,2,239,0,102,14,191,5,108,2,101,4,151,2,59,1,134,2,0,0,73,231,38,114,100,231,63,199,248,206,114,127,255,39,255,255,241,255,254,73,36,225],
		},
		///////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,111,2,239,0,99,14,185,5,121,2,98,4,155,2,61,1,142,2,0,0,73,231,38,114,100,231,63,255,243,156,159,201,39,204,255,255,252,127,255,249,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,109,2,241,0,78,14,218,5,108,2,89,4,128,2,60,1,111,2,0,0,73,231,38,114,68,156,231,255,248,206,114,71,242,79,153,255,255,255,255,249,36,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,116,2,244,0,77,14,209,5,106,2,104,4,120,2,52,1,139,2,0,0,73,231,38,114,68,156,231,248,255,206,114,127,50,124,207,255,255,255,255,228,156,194],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,109,2,241,0,74,14,221,5,91,2,121,4,123,2,57,1,114,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,227,39,204,252,127,255,255,255,153,57,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,113,2,242,0,77,14,184,5,124,2,83,4,134,2,47,1,156,2,0,0,73,231,38,114,100,231,63,199,254,115,147,31,38,124,207,255,255,255,255,242,115,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,114,2,245,0,103,14,182,5,114,2,105,4,115,2,60,1,123,2,0,0,73,231,38,114,100,231,63,255,243,156,159,196,207,153,255,255,255,255,249,51,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,110,2,237,0,89,14,192,5,118,2,100,4,162,2,44,1,137,2,0,0,73,231,38,114,100,231,63,199,254,115,147,249,207,153,255,248,255,255,255,153,204,32],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,90,2,242,0,71,14,206,5,110,2,110,4,122,2,60,1,117,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,227,159,51,241,255,255,254,63,206,115,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,106,2,242,0,80,14,204,5,105,2,119,4,138,2,57,1,146,2,0,0,73,231,38,114,68,156,231,255,248,206,114,127,36,252,207,199,255,255,255,248,231,48,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,102,2,247,0,75,14,188,5,123,2,86,4,131,2,56,1,136,2,0,0,73,231,38,114,100,231,63,252,120,206,114,127,147,243,63,255,255,255,255,36,243,8],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,130,2,236,0,98,14,167,5,137,2,79,4,119,2,42,1,182,2,0,0,73,231,38,114,100,231,63,255,243,156,159,204,252,207,199,248,255,255,255,147,204,32],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,108,2,241,0,77,14,203,5,107,2,113,4,125,2,61,1,140,2,0,0,73,231,38,114,100,231,63,199,248,206,114,127,207,204,252,127,255,255,255,153,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,103,2,243,0,90,14,201,5,111,2,106,4,137,2,52,1,143,2,0,0,73,231,38,114,68,156,231,255,248,137,206,79,228,254,103,255,255,255,255,249,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,112,2,243,0,76,14,189,5,120,2,95,4,149,2,51,1,141,2,0,0,73,231,38,114,100,231,63,199,254,115,147,252,254,103,255,227,255,255,252,159,48,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,120,2,238,0,114,14,180,5,127,2,80,4,137,2,56,1,110,2,0,0,73,231,38,114,100,231,63,255,198,115,147,249,254,103,255,255,255,255,243,230,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,99,2,243,0,73,14,193,5,121,2,91,4,101,2,71,1,128,2,0,0,73,231,38,114,68,156,231,248,255,25,206,79,255,230,127,255,255,255,254,126,97],
		},
		////////////////////////HEAT/////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,113,2,239,0,118,2,70,4,75,14,190,5,115,2,58,1,144,2,0,0,43,221,110,162,187,191,199,248,221,223,234,190,63,255,255,255,255,221,216,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,110,2,249,0,67,14,192,5,118,2,96,4,115,2,80,1,132,2,0,0,73,231,38,114,68,156,231,255,254,115,159,242,79,143,255,255,241,255,255,206,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,102,2,244,0,89,14,197,5,110,2,111,4,118,2,55,1,112,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,153,63,254,63,255,255,199,249,39,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,117,2,242,0,102,2,110,4,81,14,207,5,144,2,51,1,149,2,0,0,43,221,110,181,221,255,255,187,191,245,241,255,255,255,255,255,94,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,118,2,241,0,79,14,186,5,128,2,80,4,110,2,50,1,144,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,147,63,255,254,63,199,255,249,158,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,102,2,245,0,76,14,211,5,104,2,119,4,113,2,72,1,115,2,0,0,73,231,38,114,100,231,63,255,198,115,159,243,63,255,255,254,63,255,243,204,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,112,2,245,0,80,14,191,5,121,2,109,4,106,2,65,1,133,2,0,0,73,231,38,114,68,156,231,255,254,115,159,231,62,63,199,255,255,255,249,62,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,99,2,244,0,108,14,201,5,100,2,109,4,133,2,50,1,111,2,0,0,73,231,38,114,100,231,63,255,198,115,159,252,255,255,255,255,255,252,249,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,128,2,239,0,81,14,174,5,123,2,97,4,102,2,72,1,165,2,0,0,73,231,38,114,68,156,231,255,254,115,159,228,159,255,255,255,143,255,243,243,8],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,109,2,245,0,88,14,198,5,110,2,99,4,126,2,51,1,129,2,0,0,73,231,38,114,100,231,63,254,56,206,115,252,73,248,255,255,255,31,255,255,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,110,2,234,0,73,14,234,5,90,2,112,4,125,2,55,1,142,2,0,0,73,231,38,114,68,156,196,255,31,227,57,207,243,63,31,227,252,127,255,255,146,73,56,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,107,2,245,0,75,14,187,5,120,2,112,4,144,2,55,1,136,2,0,0,73,231,38,114,100,231,63,255,243,156,255,25,255,255,255,255,255,252,146,78,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,103,2,244,0,81,14,207,5,117,2,98,4,129,2,106,1,123,2,0,0,73,231,38,114,100,231,63,255,243,156,255,39,255,255,241,255,254,63,204,146,112,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,101,2,242,0,96,14,218,5,96,2,112,4,100,2,54,1,124,2,0,0,73,231,38,114,68,156,231,248,255,206,115,254,127,31,255,255,227,255,255,36,156,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,114,2,243,0,75,14,213,5,102,2,110,4,135,2,57,1,132,2,0,0,73,231,38,114,68,156,231,255,248,206,115,252,255,255,255,255,255,255,38,73,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,113,2,246,0,66,14,199,5,115,2,103,4,136,2,65,1,130,2,0,0,73,231,38,114,100,231,63,199,248,206,115,252,127,255,255,143,255,255,249,146,112,128],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [227,0,5,97,2,3,1,99,2,120,4,53,14,218,5,115,2,81,1,152,2,0,0,43,221,110,181,221,254,63,247,119,250,175,223,199,255,248,255,255,91,176,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [227,0,5,100,2,244,0,97,14,215,5,103,2,103,4,111,2,60,1,140,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,201,62,39,255,255,255,255,249,156,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [227,0,5,109,2,255,0,103,2,107,4,69,14,194,5,119,2,76,1,137,2,0,0,43,221,110,181,221,254,63,198,238,255,107,247,241,255,255,255,254,238,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [227,0,5,99,2,243,0,67,14,193,5,116,2,123,4,124,2,58,1,115,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,140,159,159,199,255,255,255,255,57,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [227,0,5,113,2,247,0,73,14,193,5,117,2,95,4,126,2,61,1,138,2,0,0,73,231,38,114,100,231,63,199,248,206,115,252,153,249,255,255,255,255,252,147,204,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [227,0,5,103,2,253,0,48,14,236,5,78,2,129,4,106,2,86,1,126,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,204,252,255,255,255,255,255,39,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [227,0,5,126,2,239,0,107,14,179,5,133,2,79,4,143,2,71,1,117,2,0,0,73,231,38,114,100,231,63,255,198,115,159,231,62,39,255,255,255,255,243,60,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [227,0,5,104,2,243,0,107,14,203,5,103,2,109,4,103,2,53,1,148,2,0,0,73,231,38,114,68,156,231,248,241,249,206,127,142,126,127,255,255,255,255,207,48,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [227,0,5,109,2,240,0,74,14,207,5,107,2,115,4,99,2,69,1,114,2,0,0,73,231,38,114,68,156,231,248,252,99,57,207,242,79,196,254,63,199,255,255,249,62,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [227,0,5,107,2,245,0,72,14,205,5,110,2,102,4,141,2,54,1,147,2,0,0,73,231,38,114,100,231,63,199,248,206,115,254,79,231,241,255,255,255,255,62,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [227,0,5,101,2,238,0,91,14,233,5,74,2,135,4,114,2,57,1,125,2,0,0,73,231,38,114,68,156,231,248,241,28,68,231,63,204,252,79,227,255,255,255,252,252,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [227,0,5,118,2,241,0,76,14,178,5,131,2,65,4,138,2,52,1,113,2,0,0,73,231,38,114,100,231,63,255,198,115,159,227,63,159,199,248,255,31,227,255,243,8],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [227,0,5,113,2,244,0,50,14,208,5,104,2,109,4,128,2,54,1,139,2,0,0,73,231,38,114,100,231,63,199,254,115,159,228,254,39,255,255,255,241,254,73,36,225],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [227,0,5,100,2,240,0,63,14,195,5,117,2,110,4,137,2,48,1,143,2,0,0,73,231,38,114,100,231,63,199,248,206,115,254,127,19,248,255,255,255,255,18,73,56,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [227,0,5,127,2,240,0,91,14,169,5,127,2,87,4,94,2,89,1,121,2,0,0,73,231,38,114,68,156,231,255,254,115,159,231,248,159,199,248,255,255,255,50,73,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [227,0,5,106,2,252,0,74,14,186,5,122,2,94,4,133,2,66,1,100,2,0,0,73,231,38,114,100,231,63,255,198,115,159,255,243,248,255,255,255,255,201,39,8],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [227,0,5,90,14,172,5,116,2,244,0,120,2,88,4,118,2,64,1,151,2,0,0,146,169,82,82,164,137,42,84,170,170,170,170,165,74,149,85,73,37,84,149,85,85,85,85,85,85,85,85,85,82,84,161],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [227,0,5,113,2,248,0,100,2,103,4,70,14,219,5,114,2,71,1,105,2,0,0,43,221,110,181,221,255,254,55,119,253,95,95,255,255,255,255,214,236,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [227,0,5,99,2,245,0,102,14,215,5,92,2,118,4,75,2,77,1,106,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,153,62,79,227,255,255,255,254,103,48,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [227,0,5,114,2,244,0,65,14,188,5,118,2,91,4,123,2,61,1,147,2,0,0,73,231,38,114,68,156,231,255,248,206,115,255,39,201,252,127,143,255,255,243,156,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [227,0,5,129,2,240,0,103,14,215,5,94,2,105,4,155,2,46,1,155,2,0,0,73,231,38,114,100,231,63,255,198,115,159,228,207,147,248,255,255,255,31,252,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [227,0,5,105,2,243,0,60,14,231,5,94,2,111,4,115,2,54,1,112,2,0,0,73,231,38,114,68,156,231,248,248,249,206,127,204,249,63,143,241,255,254,63,201,60,194],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [227,0,5,112,2,255,0,67,14,193,5,118,2,91,4,129,2,68,1,145,2,0,0,73,231,38,114,100,231,63,199,254,115,159,231,62,79,255,255,255,227,254,79,48,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [227,0,5,99,2,248,0,74,14,219,5,103,2,107,4,141,2,62,1,116,2,0,0,73,231,38,114,100,231,63,252,120,206,115,255,159,39,255,255,241,255,254,103,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [227,0,5,101,2,243,0,110,14,204,5,95,2,113,4,109,2,59,1,145,2,0,0,73,231,38,114,100,231,63,255,198,115,159,228,159,147,248,255,255,31,255,249,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [227,0,5,109,2,244,0,79,14,187,5,121,2,92,4,109,2,62,1,116,2,0,0,73,231,38,114,68,156,231,255,248,206,115,254,79,201,252,127,255,255,255,147,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [227,0,5,114,2,245,0,74,14,190,5,121,2,90,4,133,2,54,1,137,2,0,0,73,231,38,114,100,231,63,255,243,156,255,51,242,127,255,31,255,255,243,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [227,0,5,101,2,244,0,88,14,191,5,109,2,115,4,125,2,61,1,112,2,0,0,73,231,38,114,100,231,63,255,198,115,159,249,249,63,255,255,255,143,243,243,8],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [227,0,5,116,2,242,0,82,14,201,5,106,2,104,4,109,2,83,1,95,2,0,0,73,231,38,114,68,156,231,255,248,206,115,252,158,57,63,255,255,255,255,143,204,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [227,0,5,118,2,241,0,81,14,211,5,121,2,84,4,104,2,76,1,129,2,0,0,73,231,38,114,68,156,231,255,248,206,115,254,127,39,255,241,254,63,255,201,36,156,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [227,0,5,116,2,242,0,101,14,192,5,109,2,102,4,134,2,51,1,146,2,0,0,73,231,38,114,100,231,63,199,143,206,115,252,255,39,241,255,255,255,254,36,146,112,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [227,0,5,109,2,242,0,87,14,198,5,108,2,105,4,111,2,57,1,125,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,255,147,255,248,255,255,255,50,73,194],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,111,2,255,0,114,2,96,4,76,14,195,5,134,2,73,1,134,2,0,0,43,221,110,181,221,255,255,187,191,213,125,191,255,255,255,31,245,118,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,114,2,244,0,117,2,103,4,73,14,199,5,117,2,60,1,145,2,0,0,43,221,110,181,221,255,254,55,119,248,171,237,248,255,255,255,31,237,118,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,117,2,246,0,111,14,187,5,120,2,91,4,137,2,68,1,125,2,0,0,73,231,38,114,100,231,63,199,248,206,115,252,201,243,63,255,255,255,255,201,204,32],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,128,2,238,0,71,14,223,5,106,2,103,4,162,2,58,1,167,2,0,0,73,231,38,114,100,231,63,255,243,156,255,201,243,63,255,255,31,255,228,206,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,103,2,244,0,103,2,115,4,93,14,198,5,142,2,65,1,156,2,0,0,43,221,110,181,221,254,60,120,221,223,235,125,191,255,255,255,255,183,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,126,2,237,0,102,2,103,4,80,14,214,5,105,2,68,1,158,2,0,0,43,221,110,162,187,191,255,198,238,255,22,251,126,63,255,255,255,221,216,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,116,2,247,0,76,14,193,5,121,2,103,4,107,2,60,1,128,2,0,0,73,231,38,114,100,231,63,255,198,115,159,231,62,103,227,255,252,127,255,243,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,116,2,242,0,85,14,206,5,114,2,96,4,116,2,81,1,119,2,0,0,73,231,38,114,100,231,63,255,198,115,159,252,227,51,241,255,255,255,254,73,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,98,2,246,0,122,2,116,4,98,14,193,5,132,2,59,1,145,2,0,0,43,221,110,181,221,255,254,55,119,250,191,111,199,255,255,255,253,123,8],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,110,2,238,0,74,14,205,5,112,2,114,4,147,2,66,1,181,2,0,0,73,231,38,114,68,156,231,248,255,206,115,254,79,204,255,255,255,255,252,207,48,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,115,2,237,0,74,14,218,5,93,2,117,4,128,2,45,1,130,2,0,0,73,231,38,114,68,156,231,248,255,206,70,127,153,249,159,255,143,241,255,255,158,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,114,2,246,0,72,14,186,5,123,2,90,4,145,2,65,1,116,2,0,0,73,231,38,114,100,231,63,199,248,206,115,255,63,51,241,255,255,255,254,79,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,125,2,238,0,96,14,195,5,111,2,92,4,139,2,44,1,158,2,0,0,73,231,38,114,100,231,63,255,198,115,159,228,254,103,227,252,127,255,255,207,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,118,2,248,0,48,14,221,5,102,2,110,4,118,2,79,1,112,2,0,0,73,231,38,114,100,231,63,255,243,156,255,19,249,159,255,255,255,255,159,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,123,2,239,0,89,14,183,5,123,2,87,4,113,2,62,1,113,2,0,0,73,231,38,114,68,156,231,248,255,25,206,127,159,230,127,255,254,63,255,255,48,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,118,2,243,0,80,14,214,5,124,2,89,4,167,2,49,1,139,2,0,0,73,231,38,114,100,231,63,252,126,115,159,227,252,207,255,199,255,255,249,36,147,132],
		},
		///////////////////////////AUTO//////////////////////////////
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,116,2,241,0,87,14,179,5,132,2,71,4,111,2,62,1,143,2,0,0,73,231,38,114,68,156,231,248,248,196,103,56,231,201,63,255,255,31,255,255,252,230,16],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [227,0,5,108,2,239,0,118,14,213,5,106,2,113,4,116,2,52,1,122,2,0,0,73,231,38,114,68,156,231,248,241,227,57,196,103,201,63,159,255,199,248,255,31,243,57,132],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [227,0,5,109,2,255,0,71,14,198,5,112,2,102,4,137,2,81,1,146,2,0,0,73,231,38,114,100,231,63,255,198,115,136,207,146,126,79,255,255,227,255,252,153,204,32],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,111,2,235,0,90,14,197,5,116,2,96,4,141,2,77,1,143,2,0,0,73,231,38,114,100,231,63,199,254,115,243,228,159,153,255,255,255,255,249,147,152,64],
		},
		////////////////////////////DRY////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_AUTO",
			command: [227,0,5,86,2,255,0,62,14,221,5,96,2,131,4,119,2,69,1,141,2,0,0,73,231,38,114,68,156,231,255,248,206,113,63,146,127,255,255,255,255,254,39,204,32],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [227,0,5,105,2,243,0,55,14,235,5,78,2,135,4,105,2,65,1,115,2,0,0,73,231,38,114,68,156,231,248,241,28,103,56,159,201,63,19,255,248,255,255,255,25,230,16],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [227,0,5,109,2,244,0,103,14,201,5,102,2,85,4,96,2,54,1,130,2,0,0,73,231,38,114,68,156,231,248,255,25,206,39,242,79,201,252,127,255,255,143,243,60,194],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_HIGH",
			command: [227,0,5,122,2,243,0,77,14,198,5,124,2,81,4,129,2,52,1,149,2,0,0,73,231,38,114,68,156,231,255,248,206,113,63,146,126,103,227,255,255,255,252,147,137,132],
		},
	]
}

export default GPLUS
